import { render, staticRenderFns } from "./CategoryMaster.vue?vue&type=template&id=aaad50fc&scoped=true"
import script from "./CategoryMaster.vue?vue&type=script&lang=js"
export * from "./CategoryMaster.vue?vue&type=script&lang=js"
import style0 from "./CategoryMaster.vue?vue&type=style&index=0&id=aaad50fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaad50fc",
  null
  
)

export default component.exports